import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class JornayaService {
  private isBrowser: boolean;
  private leadIdToken: string | null = null;

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  // initializeJornaya(token1: string, token2: string): void {
  //   if (!this.isBrowser) return;

  //   this.logJornayaDebug('jornaya-service:initialize:called', {
  //     token1Len: (token1 || '').length,
  //     token2Len: (token2 || '').length,
  //   });

  //   if (document.getElementById('LeadiDscript_campaign')) {
  //     this.logJornayaDebug('jornaya-service:initialize:skipped-existing-campaign');
  //     return;
  //   }

  //   if (!document.getElementById('LeadiDscript')) {
  //     const container = document.createElement('script');
  //     container.id = 'LeadiDscript';
  //     container.type = 'text/javascript';
  //     document.body.appendChild(container);
  //     this.logJornayaDebug('jornaya-service:initialize:created-base-script');
  //   }

  //   const script = document.createElement('script');
  //   script.id = 'LeadiDscript_campaign';
  //   script.type = 'text/javascript';
  //   script.async = true;
  //   script.src = `//create.lidstatic.com/campaign/${token1}.js?snippet_version=2`;

  //   const container = document.getElementById('LeadiDscript');
  //   if (container) {
  //     container.parentNode?.insertBefore(script, container);
  //     this.logJornayaDebug('jornaya-service:initialize:inserted-campaign', {
  //       src: script.src,
  //     });
  //   }

  //   if (!document.getElementById('LeadiDscript_noscript')) {
  //     const noscript = document.createElement('noscript');
  //     noscript.id = 'LeadiDscript_noscript';
  //     const img = document.createElement('img');
  //     img.src = `//create.leadid.com/noscript.gif?lac=${token2}&lck=${token1}&snippet_version=2`;
  //     noscript.appendChild(img);
  //     document.body.appendChild(noscript);
  //     this.logJornayaDebug('jornaya-service:initialize:inserted-noscript', {
  //       src: img.src,
  //     });
  //   }
  // }

  private isDebugJornayaEnabled(): boolean {
    const search = this.isBrowser ? window.location.search : '';
    if (!search) return false;
    const value = new URLSearchParams(search).get('debugJornaya')?.trim().toLowerCase();
    return value === '1' || value === 'true' || value === 'yes';
  }

  private logJornayaDebug(stage: string, details: Record<string, unknown> = {}): void {
    if (!this.isDebugJornayaEnabled()) return;
    console.log(`[JORNAYA-DEBUG][jornaya-service] stage=${stage}`, details);
  }

}
